import { render, staticRenderFns } from "./drawer-set-password.vue?vue&type=template&id=ae1d3814&"
import script from "./drawer-set-password.vue?vue&type=script&lang=ts&"
export * from "./drawer-set-password.vue?vue&type=script&lang=ts&"
import style0 from "./drawer-set-password.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports